import CityPageTemplate from "../city-template/CityPageTemplate";
import { springfieldVaConfig } from "./data";

export default function SpringfieldVaPage() {
  return <CityPageTemplate config={springfieldVaConfig} />;
}